import { AxiosError } from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { api, TMSResponse } from './service-api';
import { httpClient } from 'redux/reducers/settings';
import { toast } from 'react-toastify';

export interface ICousreResponse {
  course_category_id: number;
  name: string;
  description: string;
}

export type ICourse = Array<{
  id: number;
  title: string;
  code: string;
  description: string;
  duration_hr: number;
  image: string;
  price: number;
  is_enrolled: boolean;
  publish: boolean;
  course_category_details: {
    course_category_id: number;
    name: string;
    description: string;
  };
  course_resource_list: [
    {
      name: string;
      file: string;
      // resource_type: jpeg
    }
  ];
}>;
export interface IFilteredCourse {
  id: number;
  title: string;
  code: string;
  description: string;
  duration_hr: number;
  image: string;
  price: number;
  publish: boolean;
  category_details: {
    course_category_id: number;
    name: string;
    description: string;
  };
  // course_resource_list: [
  //   {
  //     name: string;
  //     file: string;
  //     // resource_type: jpeg
  //   }
  // ];
}
export interface ICardDetail {
  course_topic_id: string;
  title: string;
  description: string;
  duration_hr: number;
  methodology: string;
  order: number;
  learning_objective: string;
  course_topic_details: {
    course_details: {
      course_id: number;
      title: string;
      code: string;
    };
    title: string;
  };

  course_topic_files_list: [];
}

const fetchAllCourse = () => {
  return httpClient.get<TMSResponse<ICourse>>(api.allcourse);
};

const useListAllCourseQuery = () => {
  return useQuery(api.allcourse, fetchAllCourse, {
    select: ({ data }) => {
      return data.data;
    },
    keepPreviousData: true
  });
};

const fetchonGoingCourse = () => {
  return httpClient.get<TMSResponse<ICourse>>(api.allcourse);
  // return httpClient.get<TMSResponse<ICourse>>(api.onGoingCourse);
};

const useListOnGoingCourseQuery = () => {
  return useQuery(api.allcourse, fetchonGoingCourse, {
    // return useQuery(api.onGoingCourse, fetchonGoingCourse, {
    select: ({ data }) => {
      return data.data;
    },
    keepPreviousData: true
  });
};

const fetchThisCategory = (id: any) => () => {
  return httpClient.get<TMSResponse<Array<IFilteredCourse>>>(
    api.coursePerCategory.replace('{category_id}', id)
  );
};

//fetch 1 course category
const useFetchThisCategoryQuery = (id: string) => {
  return useQuery([api.coursePerCategory, id], fetchThisCategory(id ?? ''), {
    select: ({ data }) => {
      return data.data;
    },
    enabled: !!id,
    keepPreviousData: true
  });
};

const fetchCourseList = () => {
  return httpClient.get<TMSResponse<ICousreResponse[]>>(api.courseCategory);
};
//fetch course category list
const useFetchListQuery = () => {
  return useQuery(api.courseCategory, fetchCourseList, {
    select: ({ data }) => {
      return data.data;
    },
    keepPreviousData: true,
    onError: (error: AxiosError) => {
      toast.error('Failed to load course category lsit');
    }
  });
};

const fetchThisCourseId = (id: string) => () => {
  return httpClient.get<TMSResponse<Array<ICardDetail>>>(
    api.courseDetailById.replace('{courseId}', id)
  );
};
//fetch course category details of given Id
const useFetchThisCourseIdQuery = (id: any) => {
  return useQuery([api.courseDetailById, id], fetchThisCourseId(id ?? ''), {
    select: ({ data }) => {
      return data.data;
    },
    keepPreviousData: true,
    onError: (error: AxiosError) => {
      toast.error('Something is wrong');
    }
  });
};

const fetchThisSessionresource = (id: string, type: string) => () => {
  return httpClient.get<TMSResponse<any>>(
    api.resourcePerSession.replace('{id}', id).replace('{type}', type)
    // api.resourcePerSession,
    // {
    //   course_topic: id,
    //   resource_type: type
    // }
  );
};
//fetch course category details of given Id
const useFetchThisSessionresourceQuery = (id: any, type: string) => {
  return useQuery(
    [api.resourcePerSession, id, type],
    fetchThisSessionresource(id ?? '', type ?? ''),
    {
      select: ({ data }) => {
        return data.data;
      },
      keepPreviousData: true,
      enabled: !!id,
      onError: (error: AxiosError) => {
        toast.error('Failed to fetch resources');
      }
    }
  );
};

const fetchThisSessionAssignment = (id: string) => () => {
  return httpClient.get<TMSResponse<any>>(api.assignmentsPerSession.replace(':id', id));
};
const useFetchThisSessionAssignmentQuery = (id: any) => {
  return useQuery([api.assignmentsPerSession, id], fetchThisSessionAssignment(id ?? ''), {
    select: ({ data }) => {
      return data;
    },
    keepPreviousData: true,
    enabled: !!id,
    onError: (error: AxiosError) => {
      toast.error('Failed to load Assignments');
    }
  });
};

const fetchThisAssignmentMCQ = (id: string) => () => {
  return httpClient.get<TMSResponse<any>>(api.mcqPerAssignment.replace('id', id));
};
const useFetchThisAssignmentMCQQuery = (id: any) => {
  return useQuery([api.mcqPerAssignment, id], fetchThisAssignmentMCQ(id ?? ''), {
    select: ({ data }) => {
      return data.data;
    },
    keepPreviousData: true,
    enabled: !!id,
    onError: (error: AxiosError) => {
      toast.error('Failed to fetch MCQ.Try again');
    }
  });
};

const sendThisAssignmentAnswer = (mcqAns: any) => {
  return httpClient.post<TMSResponse>(
    api.sendAssignmentAnswer.replace('id', mcqAns?.assignment_id),
    mcqAns
  );
};
const useSendThisAssignmentAnswerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(sendThisAssignmentAnswer, {
    onSuccess: () => {
      queryClient.invalidateQueries(api.assignmentsPerSession);

      toast.success('Your answer is submitted');
    },
    onError: (error: AxiosError) => {
      toast.error('Your answer was not submitted');
    }
  });
};

const fetchThisAssignmentMCQResult = (id: string) => () => {
  return httpClient.get<TMSResponse<any>>(api.getMcqResult.replace('assignment_id', id));
};
const useFetchThisAssignmentMCQResultQuery = (id: any) => {
  return useQuery([api.getMcqResult, id], fetchThisAssignmentMCQResult(id ?? ''), {
    select: ({ data }) => {
      return data;
    },
    keepPreviousData: true,
    enabled: !!id,
    onError: (error: AxiosError) => {
      toast.error('failed to load MCQ result');
    }
  });
};
const userCourseEnroll = (courseId: { course: number }) => {
  return httpClient.post<TMSResponse>(api.courseEnroll, courseId);
};
const useUserCourseEnrollQuery = () => {
  const queryClient = useQueryClient();

  return useMutation(userCourseEnroll, {
    onSuccess: (res) => {
      if (res.data)
        queryClient.invalidateQueries(api.courseEnroll);

      toast.success('You are enrolled!');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message ?? 'Enroll Failed');
    }
  });
};
export {
  useFetchListQuery,
  useFetchThisAssignmentMCQQuery,
  useFetchThisAssignmentMCQResultQuery,
  useFetchThisCategoryQuery,
  useFetchThisCourseIdQuery,
  useFetchThisSessionAssignmentQuery,
  useFetchThisSessionresourceQuery,
  useListAllCourseQuery,
  useListOnGoingCourseQuery,
  useSendThisAssignmentAnswerMutation,
  useUserCourseEnrollQuery
};
